export const NAVIGATION_DISABLE = 'NAVIGATION_DISABLE';
export const NAVIGATION_ENABLE = 'NAVIGATION_ENABLE';
